/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit} from '@angular/core';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-library-creative-list-context',
  template: `
    <a *ngIf="!readOnly"
       class="btn btn-default btn-xs"
       [attr.href]="bulkUploadHref"
       (click)="goToBulkUpload($event)">
      <span class="fa fa-fw fa-plus-circle"></span>
      <span>Bulk Upload</span>
    </a>
    <a *ngIf="!readOnly"
       name="adnListNew"
       class="btn btn-default btn-xs"
       style="margin-left: 5px"
       [attr.href]="newCreativeHref"
       (click)="goToNewCreative($event)">
      <span class="fa fa-fw fa-plus-circle"></span>
      <span>{{ 'button.add.new' | ogTranslate }}</span>
    </a>
  `
})
export class LibraryCreativeListContextComponent implements OnInit {
  @Input() readOnly: boolean;

  newCreativeHref = '';
  bulkUploadHref = '';
  private newStateName = '';
  private bulkUploadStateName = '';

  constructor(private readonly $state: StateService) {
  }

  ngOnInit(): void {
    this.updateRoutes();
  }

  goToNewCreative(event: Event): void {
    event.preventDefault();
    this.$state.go(this.newStateName);
  }

  goToBulkUpload(event: Event): void {
    event.preventDefault();
    this.$state.go(this.bulkUploadStateName);
  }

  private updateRoutes(): void {
    const isLibrary = this.$state.includes('app.adv.library-creatives');
    if (isLibrary) {
      this.newCreativeHref = '/library-creatives/new';
      this.bulkUploadHref = '/library-creatives/bulk-upload';
      this.newStateName = 'app.adv.library-creatives.new';
      this.bulkUploadStateName = 'app.adv.library-creatives.bulkupload';
    } else {
      // Hard-code the list URL so we never resolve a relative ui-sref like ".new"
      // (context components have no UI-Router reference point).
      this.newCreativeHref = '/creatives/new';
      this.bulkUploadHref = '/creatives/bulk-upload';
      this.newStateName = 'app.adv.creatives.new';
      this.bulkUploadStateName = 'app.adv.creatives.bulkupload';
    }
  }
}
